import axios from 'axios';
import { getTokenCredentials } from '../../../Shared/functions';
import { BASE_API } from '../../../Shared/Constants';

export function getAllLists(body){
    return axios.post(BASE_API + 'api/sync/syncapk', body , {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Basic '+getTokenCredentials()
        }
    })
    .then(response => {return response})
    .catch(error => {
        if(error.error === -100) {
            return []
        }
    });
}

export function createPenalitie(body) {
    return axios.post(BASE_API + 'api/fine/register', body , {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Basic '+getTokenCredentials()
        }
    })
    .then(response => {return response})
    .catch(error => {
        if(error.error === -100) {
            return []
        }
    });
}

export function getAllPenalities(body){
    return axios.post(BASE_API + 'api/fine/getlist', body , {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Basic '+getTokenCredentials()
        }
    })
    .then(response => {return response})
    .catch(error => {
        if(error.error === -100) {
            return []
        }
        return error.response.data.message;
    });
}

export function getPaymentHistoric(body) {
    return axios.post(BASE_API + 'api/payment/getlist', body , {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Basic '+getTokenCredentials()
        }
    })
    .then(response => {return response})
    .catch(error => {
        if(error.error === -100) {
            return []
        }
    });
}

export function penalitieStatus(body){
    return axios.post(BASE_API + 'api/fine/updatestatus', body , {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Basic '+getTokenCredentials()
        }
    })
    .then(response => {
        return response
    })
    .catch(error => {
        if(error.error === -100) {
            return []
        }
        return error.response.data.message;
    });
}

export function savePayment(body){
    return axios.post(BASE_API + 'api/payment/admintwo', body , {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Basic '+getTokenCredentials()
        }
    })
    .then(response => {return response})
    .catch(error => {
        if(error.error === -100) {
            return []
        }
        return error;
    });
}

// Pago móvil de una o varias multas (todos sus conceptos) en un solo POST.
// Igual que el resto de servicios: en error devuelve el mensaje del backend
// como string para que el componente pueda mostrarlo.
export function savePaymentMultiple(body){
    return axios.post(BASE_API + 'api/payment/pm', body , {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Basic '+getTokenCredentials()
        }
    })
    .then(response => response)
    .catch(error => {
        if(error.error === -100) {
            return []
        }
        return error?.response?.data?.message || error?.message || 'No se pudo registrar el pago';
    });
}

export function createUser(body){
    return axios.post(BASE_API + 'api/user/register/from/admin', body , {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Basic '+getTokenCredentials()
        }
    })
    .then(response => {return response})
    .catch(error => {
        if(error.error === -100) {
            return []
        }
        throw error.response.data.message;
    });
}

export function updateUser(body){
    return axios.post(BASE_API + 'api/user/update/email', body , {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Basic '+getTokenCredentials()
        }
    })
    .then(response => {return response})
    .catch(error => {
        if(error.error === -100) {
            return []
        }
        throw error.response.data.message;
    });
}

export function updateData(body) {
    return axios.post(BASE_API + 'api/user/update/from/admin', body , {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Basic '+getTokenCredentials()
        }
    })
    .then(response => {return response})
    .catch(error => {
        if(error.error === -100) {
            return []
        }
        // Si no hay error.response (red/timeout/CORS), acceder a .data.message
        // lanzaría un TypeError y el mensaje real se perdería; degradar a un string.
        throw (error && error.response && error.response.data && error.response.data.message)
            ? error.response.data.message
            : 'No se pudieron actualizar los datos. Verifique su conexión e intente nuevamente.';
    });

}